const KEY = "openclaw.office.telegram.bootstrap.v1";
type StorageReader = Pick<Storage, "getItem" | "removeItem">;
export function consumeTelegramOfficeBootstrap(
  storage: StorageReader | null,
  origin: string,
  now = Date.now(),
): { token: string } | null {
  try {
    const raw = storage?.getItem(KEY);
    storage?.removeItem(KEY);
    if (!raw || raw.length > 4096) return null;
    const value = JSON.parse(raw) as Record<string, unknown>;
    if (
      value.version !== 1 ||
      value.origin !== origin ||
      !origin.startsWith("https://") ||
      typeof value.token !== "string" ||
      !value.token ||
      value.token.length > 2048 ||
      typeof value.expiresAtMs !== "number" ||
      !Number.isSafeInteger(value.expiresAtMs) ||
      value.expiresAtMs <= now ||
      value.expiresAtMs > now + 660000
    )
      return null;
    return { token: value.token };
  } catch {
    return null;
  }
}
